/**
 * 从后向前查找数组中满足条件的最后一个元素的索引
 * @param array 要搜索的数组
 * @param predicate 判断条件函数
 * @returns 找到则返回索引，否则返回 -1
 */
export default function findLastIndex<T>(
  array: T[], 
  predicate: (value: T, index: number, array: T[]) => boolean
): number {
  for (let i = array.length - 1; i >= 0; i--) {
    if (predicate(array[i], i, array)) {
      return i;
    }
  }
  return -1;
}
